module.exports = __webpack_public_path__ + "img/question.9bd123ec.png";